<template>
  <el-dialog
    :title="$t('dictManage.confirmOperation')"
    :visible.sync="dialogVisible"
    width="30%"
  >
    <div class="text-center">
      <p>{{ $t('dictManage.confirmDeleteDict') }}</p>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">
        {{ $t('dictManage.cancel') }}
      </el-button>
      <el-button 
        type="primary" 
        @click="deleteDict"
      >
        {{ $t('dictManage.confirmDelete') }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { deleteDict } from '@/api/dev/dictApi'

export default {
  name: 'DeleteDict',
  data() {
    return {
      dialogVisible: false,
      deleteDictInfo: {}
    }
  },
  methods: {
    open(row) {
      this.dialogVisible = true
      this.deleteDictInfo = { ...row }
      console.log(this.deleteDictInfo)
    },
    async deleteDict() {
      try {
        await deleteDict(this.deleteDictInfo)
        this.$message.success(this.$t('dictManage.deleteSuccess'))
        this.dialogVisible = false
        this.$emit('refresh')
      } catch (error) {
        console.error('删除字典失败:', error)
      }
    }
  }
}
</script>

<style scoped>
.text-center {
  text-align: center;
}
</style>